import { observable } from "mobx";

export default class PostModel {
    id = Math.random();
    @observable title = "";
    @observable status = 'open';
    @observable type = 'incident';
    @observable clusters = [];
    @observable createduserid = null;
    @observable lastchangeduserid = null;
    @observable lastchangeddatetime = null;
    @observable createddatetime = null;
    @observable expiry = new Date(new Date().getTime() + 864e5);
    @observable messages = [];
    @observable description = "";

    constructor(id, title, type, status, clusters, description, expiry, lastchangeddatetime) {
        if (id != null) this.id = id;
        if (title != null) this.title = title;
        if (type != null) this.type = type;
        if (status != null) this.status = status;
        if (clusters != null) this.clusters = clusters;
        if (description != null) this.description = description;
        if (expiry != null) this.expiry = expiry;            
        if (lastchangeddatetime != null) this.lastchangeddatetime = lastchangeddatetime;
    }
}


// WEBPACK FOOTER //
// ./src/models/PostModel.js